"use client";
import Button from "@/components/common/Button";
import List, { type ListProps } from "@/components/common/List";
import { type SingleLineItem } from "@/components/navigation/types";

export type NavButtonListProps = Omit<ListProps<SingleLineItem>, "renderItem">;

export default function NavButtonList(props: NavButtonListProps) {
  const { items, ...restProps } = props;

  if (items.length === 0) {
    return null;
  }

  return (
    <List
      items={items}
      renderItem={(item) => (
        <Button href={item.url} openInNewTab={item.openInNewTab}>
          {item.label}
        </Button>
      )}
      {...restProps}
    />
  );
}
